// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-container {
  margin-top: 10px;
  margin-bottom: 10px;
}

.search-group .search-control {
  float: left;
  width: calc(100% - 30px);
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #464a4c;
  background-color: #fff;
  background-image: none;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.search-group .search-append {
  position: relative;
  top: 3px;
  margin-left: 3px;
  width: 24px;
  float: left;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/search-control/search-control.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,mBAAA;AACJ;;AAGI;EACI,WAAA;EACA,wBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,sBAAA;EACA,oCAAA;EACA,4BAAA;EACA,qCAAA;EAIA,wEAAA;AACR;AAGI;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;AADR","sourcesContent":[".search-container {\n    margin-top:10px;\n    margin-bottom:10px;\n}\n\n.search-group {\n    .search-control {\n        float: left;\n        width: calc(100% - 30px);\n        padding: .5rem .75rem;\n        font-size: 1rem;\n        line-height: 1.25;\n        color: #464a4c;\n        background-color: #fff;\n        background-image: none;\n        -webkit-background-clip: padding-box;\n        background-clip: padding-box;\n        border: 1px solid rgba(0,0,0,.15);\n        -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;\n        transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;\n        -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;\n        transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;\n        transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;\n    }\n\n    .search-append {\n        position: relative;\n        top: 3px;\n        margin-left: 3px;\n        width: 24px;\n        float: left;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
